import SimpleRichText from "@/components/SimpleRichText";
import { SimpleRichTextProps } from "@/components/SimpleRichText/SimpleRichText";
import { Container, Article } from "./styles";

const PaddingRichText: React.FC<SimpleRichTextProps> = (props) => {
  return (
    <Container>
      <Article>
        <SimpleRichText {...props} />
      </Article>
    </Container>
  );
};

export default PaddingRichText;
